import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Spin } from "antd";
import PATHS from "./path";

const Home = lazy(() => import("../pages/home/Home.jsx"));
const Services = lazy(() => import("../pages/services/Services.jsx"));
const About = lazy(() => import("../pages/about/About.jsx"));
const Contact = lazy(() => import("../pages/contact/Contact.jsx"));
const PageNotFound = lazy(
  () => import("../pages/pagenotfound/PageNotFound.jsx"),
);
const Announcements = lazy(
  () => import("../pages/announcements/Announcements.jsx"),
);
const Categories = lazy(() => import("../pages/categories/Categories.jsx"));
const Servers = lazy(() => import("../pages/servers/Servers.jsx"));
const AnnouncementDetail = lazy(
  () => import("../pages/announcementDetail/AnnouncementDetail.jsx"),
);
const AdminUsers = lazy(() => import("../pages/adminUsers/AdminUsers.jsx"));
const ProtectedAdminRoute = lazy(() => import("./ProtectedAdminRoute.jsx"));
const NotAuthorized = lazy(
  () => import("../pages/notAuthorized/NotAuthorized.jsx"),
);

function AppRoutes() {
  return (
    <Suspense
      fallback={
        <div className="page-loader">
          <Spin size="large" />
        </div>
      }
    >
      <Routes>
        <Route
          path={PATHS.ROOT}
          element={<Navigate to={PATHS.HOME} replace />}
        />
        <Route path={PATHS.HOME} element={<Home />} />
        <Route path={PATHS.SERVICES} element={<Services />} />
        <Route path={PATHS.ABOUT} element={<About />} />
        <Route path={PATHS.CONTACT} element={<Contact />} />
        <Route path={PATHS.ANNOUNCEMENTS} element={<Announcements />} />
        <Route path={PATHS.ANNOUNCEMENT} element={<AnnouncementDetail />} />
        <Route path={PATHS.CATEGORIES} element={<Categories />} />
        <Route path={PATHS.CATEGORY} element={<Servers />} />
        <Route
          path={PATHS.USER_MANAGEMENT}
          element={
            <ProtectedAdminRoute>
              <AdminUsers />
            </ProtectedAdminRoute>
          }
        />
        <Route path={PATHS.NOT_AUTHORIZED} element={<NotAuthorized />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
